import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSunLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 1.5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m0 17a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1M19.425 4.575a1 1 0 0 1 0 1.415L18.01 7.404a1 1 0 1 1-1.414-1.414l1.414-1.415a1 1 0 0 1 1.415 0M7.404 16.596a1 1 0 0 1 0 1.414L5.99 19.425a1 1 0 0 1-1.415-1.415l1.415-1.414a1 1 0 0 1 1.414 0M22.5 12a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-17 0a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1M19.425 19.425a1 1 0 0 1-1.415 0l-1.414-1.415a1 1 0 0 1 1.414-1.414l1.415 1.414a1 1 0 0 1 0 1.415M7.404 7.404a1 1 0 0 1-1.414 0L4.575 5.99A1 1 0 1 1 5.99 4.575L7.404 5.99a1 1 0 0 1 0 1.414M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M6.5 12a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSunLine)
export default ForwardRef
